export default {
  title: "Historial de cálculos",
  type: "Tipo",
  routeSearch: "Búsqueda de ruta",
  batchId: "ID de lote",
  createdAt: "Creado el",
  totalDistance: "Distancia total (km)",
  productionEmission: "Emisión de producción (kg CO2e)",
  transportEmission: "Emisión de transporte (kg CO2e)",
  totalEmission: "Emisión total (kg CO2e)",
  taxInEUR: "Impuesto (€)",
  action: "Acción",
  detail: "Detalle",
  deleteConfirm: "¿Está seguro de que desea eliminar este registro?",
  data: "Datos",
  reports: "Informes",
  batchDownload: "Descarga por lotes",
  batchDownloadPdf: "Descarga PDF por lotes",
  batchDownloadExcel: "Descarga Excel por lotes",
  selectPlaceholder: "Por favor seleccione al menos un registro",
  quotaInsufficient: "Cuota insuficiente, por favor actualice o compre",
  batchDownloadSuccess: "Descarga por lotes completada, selección reiniciada",
  batchDownloadFailed: "Error en la descarga por lotes",
  emptyFile: "El archivo generado está vacío",
  downloadProgress: "Progreso de descarga",
  completed: "completado",
  but: "pero",
  regenerate: "Regenerar",
};
